import Footer from './Footer'
// Uncomment the below to migrate to stateful component
// import FooterContainer from './FooterContainer'

export { Footer }
export default Footer
// Uncomment the below to migrate to stateful component
// export { FooterContainer }
// export default { FooterContainer }
